export default __webpack_public_path__ + "static/media/gallery_05.59f15322.jpg";